import { request } from 'lib';
import user from './index';
import { UiToast } from 'components';

let followList = new Map();

const isFollowed = (roomId, cb) => {
  if (followList.has(roomId)) {
    return followList.get(roomId);
  }

  if (!user.isLogin()) {
    return cb(false);
  }

  request.api
    .get(`user/is_following?access_token={access_token}&id1=${roomId}`)
    .then((res) => {
      followList.set(roomId, res.data.following);
      cb(res.data.following);
    })
    .catch(() => {});
};

const addFollow = (roomId, cb) => {
  user.afterLogin(() => {
    if (roomId === user.getUserId()) {
      return UiToast.info('不能关注自己');
    }
    request.api
      .get(`user/add_following/{access_token}/${roomId}`)
      .then((res) => {
        followList.set(roomId, true);
        cb && cb(true);
        UiToast.success('关注成功');
      })
      .catch((res) => {
        UiToast.fail(res.msg || '关注失败');
      });
  });
};

const delFollow = (roomId, cb) => {
  user.afterLogin(() => {
    request.api
      .get(`user/del_following/{access_token}/${roomId}`)
      .then((res) => {
        followList.set(roomId, false);
        cb && cb(false);
        UiToast.success('已取消关注');
      })
      .catch((res) => {
        UiToast.fail(res.msg || '取消关注失败');
      });
  });
};

export default {
  isFollowed,
  addFollow,
  delFollow,
};
